import http from '@services/http'
import {
  IChatBlockUserInfos,
  IFindChatEmoticon,
  IGetCheerForTeamMatchInfo,
  IGetCheerForTeamMatchList,
  ISharedBettingHistoryList,
} from '@protocol/chat'

export default {
  getEmoticonList(params: IFindChatEmoticon.Params): Promise<IFindChatEmoticon.Response> {
    return http.get('chat/emoticonList', params)
  },
  getChatBlockUserInfos(): Promise<IChatBlockUserInfos.Response> {
    return http.get('chat/getChatBlockUserInfos', {})
  },
  getCheerForTeamMatchList(params: IGetCheerForTeamMatchList.Params): Promise<IGetCheerForTeamMatchList.Response> {
    return http.get('chat/cheerForTeamMatchList', params)
  },
  getCheerForTeamMatchInfo(params: IGetCheerForTeamMatchInfo.Params): Promise<IGetCheerForTeamMatchInfo.Response> {
    return http.get('chat/cheerForTeamMatchInfo', params)
  },
  getMySharedBettingHistoryChatMessages(params: ISharedBettingHistoryList.Params)
    : Promise<ISharedBettingHistoryList.Response> {
    return http.get('chat/mySharedBettingHistoryChatMessages', params)
  },
}
